import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { STATIC_STRINGS } from "../../utils/Constants";
import { StepOneState } from "../types";

const initialState: StepOneState = {
  title: STATIC_STRINGS.UNTITLED_ASSESSMENT,
  jobDesignation: "",
  experience: [1, 2],
  skills: [],
};

const stepOneSlice = createSlice({
  name: "stepOne",
  initialState,
  reducers: {
    updateTitle: (state, action: PayloadAction<string>) => {
      state.title = action.payload;
    },
    updateJobDesignation: (state, action: PayloadAction<string>) => {
      state.jobDesignation = action.payload;
    },
    updateExperience: (state, action: PayloadAction<number[]>) => {
      state.experience = action.payload;
    },
    updateSkills: (state, action: PayloadAction<string[]>) => {
      state.skills = action.payload;
    },
    resetStepOne: () => initialState,
  },
});

export const {
  updateTitle,
  updateJobDesignation,
  updateExperience,
  updateSkills,
  resetStepOne,
} = stepOneSlice.actions;
export default stepOneSlice.reducer;
